module.exports = __webpack_public_path__ + "img/72.92ce0f63.jpg";